import { Component, Input } from '@angular/core';
import { RequeteModifierCoordonnees } from 'src/app/api/model/requete-modifier-coordonnees.model';
import { TelephonesTypeTelephoneEnum } from 'src/app/api/model/telephones.model';

@Component({
  selector: 'app-valider-telephone',
  templateUrl: './valider-telephone.component.html',
  standalone: false,
})
export class ValiderTelephoneComponent {
  @Input() requeteModifierCoordonnees: RequeteModifierCoordonnees;

  constructor() {}

  getTelephonePrincipal() {
    return this.requeteModifierCoordonnees?.telephones?.find(
      (tel) => tel.typeTelephone === TelephonesTypeTelephoneEnum.PRINCIPAL
    );
  }

  getTelephoneSecondaire() {
    return this.requeteModifierCoordonnees?.telephones?.find(
      (tel) => tel.typeTelephone === TelephonesTypeTelephoneEnum.SECONDAIRE
    );
  }

  getTelephoneEmployeur() {
    return this.requeteModifierCoordonnees?.telephones?.find(
      (tel) => tel.typeTelephone === TelephonesTypeTelephoneEnum.EMPLOYEUR
    );
  }
}
